<script>
export default {
	name: 'MasKargo404Layout',
	expose: [],
	inheritAttrs: false,
};
</script>


<script setup>
import ExperienceFragment from '~/aem-components/ExperienceFragment.vue';


</script>


<template>
<div class="MasKargo404Layout flex flex-col min-h-screen" data-layout="MasKargo404">
	<ExperienceFragment
		class="global-header"
		xfPath="/content/experience-fragments/maskargo/$lang/site/header/master"
	/>
	<div id="content"></div>
	<main class="layout-container-center">
		<slot></slot>
	</main>
	<ExperienceFragment
		class="global-cookies-notification"
		xfPath="/content/experience-fragments/maskargo/$lang/site/cookies-notification/master"
	/>

	<ExperienceFragment
		class="global-footer"
		xfPath="/content/experience-fragments/maskargo/$lang/site/footer/master"
	/>
</div>
</template>



<style scoped lang="scss">
@use '~/styles/partials/_var.scss';

.MasKargo404Layout {
	// background-color: #f0f3f5;
	// background-image: url('~/assets/enrich-songket-repeatable-x.png');
	// background-repeat: repeat-x;
	// background-position: center 100%;
}

:slotted([data-component="AEMPage"]) {
	
}
</style>
